import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a notifications icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NotificationsIcon width={12} />
 */
const NotificationsIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M16.727 18.182c-0.028 0.447-0.326 0.727-0.726
            0.727s-0.699-0.285-0.727-0.727c-0.030-0.442-0.242-4.117-0.242-4.117
            0-0.535 0.434-0.97 0.97-0.97 0.534 0 0.968 0.435 0.968 0.97 0
            0-0.214 3.669-0.242 4.117z`}
        />
        <path
            d={`M16.969 20.848c0 0.535-0.434 0.969-0.97 0.969-0.534
            0-0.968-0.434-0.968-0.969s0.434-0.97 0.968-0.97c0.536 0 0.97
            0.434 0.97 0.97z`}
        />
        <path
            d={`M16 8.242c0.512 0 1.024 0.349 1.413 1.048l6.992 11.932c0.776
            1.399-0.017 2.535-1.616 2.535h-13.576c-1.6
            0-2.393-1.167-1.616-2.565l6.992-11.902c0.389-0.699 0.9-1.048
            1.413-1.048zM16 6.303c-1.253 0-2.385 0.745-3.109 2.046l-6.991
            11.9c-0.712 1.283-0.756 2.639-0.119 3.722s1.964 1.725 3.431
            1.725h13.576c1.467 0 2.795-0.613
            3.431-1.695s0.593-2.439-0.119-3.722l-6.992-11.931c-0.723-1.301-1.855-2.046-3.108-2.046v0z`}
        />
    </SvgIcon>
)

NotificationsIcon.defaultProps = defaultProps

export { NotificationsIcon }
